import React, { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'

import SkeletonListRow from '../../../../../features/components/List/Skeleton'
import PageSection from '../../../../../features/components/PageSection'

import { listItemsTableColumnsMinWidth } from '../../../../../features/components/ListItemsTable/columnsWidth'
import { lineItemNameColWidth } from './LineItemsBreakdownList'

function SkeletonLineItemsBreakdown() {
  // columns that are used for LineItemsList component
  const itemsListColumns = useMemo(
    () => [
      {
        headTitle: () => '',
        Component: () => '',
        style: {
          minWidth: lineItemNameColWidth
        }
      },
      {
        headTitle: () => '',
        Component: () => '',
        style: {
          minWidth: listItemsTableColumnsMinWidth.impressions
        }
      },
      {
        headTitle: () => '',
        Component: () => '',
        style: {
          minWidth: listItemsTableColumnsMinWidth.reach
        }
      },

      {
        headTitle: () => '',
        Component: () => '',
        style: {
          minWidth: listItemsTableColumnsMinWidth.clicks
        }
      },
      {
        headTitle: () => '',
        Component: () => '',
        style: {
          minWidth: listItemsTableColumnsMinWidth.engagements
        }
      },
      {
        headTitle: () => '',
        Component: () => '',
        style: {
          minWidth: listItemsTableColumnsMinWidth.spend
        }
      }
    ],
    []
  )

  return (
    <PageSection>
      <SkeletonListRow key={uuidv4()} cols={itemsListColumns} />
      <SkeletonListRow key={uuidv4()} cols={itemsListColumns} />
      <SkeletonListRow key={uuidv4()} cols={itemsListColumns} />
    </PageSection>
  )
}

export default SkeletonLineItemsBreakdown
